import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { DownloadButton } from "../Buttons/DownloadButton/DownloadButton";
import { StyledLink } from "../Buttons/StyledLink/StyledLink";
import { Subtitle } from "../Subtitle/Subtitle";
import { Title } from "../Title/Title";
import * as styles from "./header.module.scss";
import eaoM from "../../../static/images/EAO_bandeauRouge_mobile.svg";
import eaoD from "../../../static/images/EAO_bandeauRouge_desktop.svg";
import pdfProgramme from "../../../static/pdf/EAO-SPBR_synopsis-V2.pdf";
import logo from "../../../static/images/logoEAO.svg";
import { gtagSendEvent } from "../../pages";

export const Header: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <img src={logo} alt={"logo"} />
      </div>
      <div className={styles.main}>
        <Title text={"EAO SPRING BREAK"} className={styles.title} />
        <Subtitle text={"Workshops & Network"} className={styles.subtitle} />
      </div>

      <div className={styles.label}>
        <img src={eaoM} alt={"flag"} className={styles.svgM} />
        <img src={eaoD} alt={"flag"} className={styles.svgD} />
        {/* <Title text={"19-21 MAY 2022"} className={styles.title} /> */}
      </div>

      <div className={styles.footer}>
        <DownloadButton
          link={pdfProgramme}
          text={"Download Programme"}
          className={styles.download}
          onClick={() => gtagSendEvent("download_programm", "desktop_header")}
        />
        <StyledLink
          link={"https://eao.org/eao-spring-break-2022/ "}
          text={"register now"}
          className={styles.button}
          onClick={() => gtagSendEvent("register", "desktop_header")}
        />
      </div>
    </div>
  );
};
